import { TFunction } from 'react-i18next'
import api from '../../../api'
import { CampaignStatus, VoohCampaign } from '../../../types/campaign'
import EnumUtils from '../../../utils/enum'
import { NotifierType } from '../../../components/Notifier'
import { GetVoohCampaignsArgs, VoohCampaignTableItem } from './types'

export default class VoohCampaignTableService {
  static getVoohCampaigns = (args: GetVoohCampaignsArgs): void => {
    const {
      pageNumber,
      itemsPerPage,
      setCampaigns,
      setTotalCount,
      setLoading,
      setTrigger,
      tableFilter,
      filters,
    } = args

    setLoading(true)
    const { brandOrNetworkSelected, ...filtersObj } = filters

    let brandOrNetworkSelectedVal: boolean | null = false

    if (
      !brandOrNetworkSelected ||
      brandOrNetworkSelected.length === 0 ||
      brandOrNetworkSelected.length === 2
    ) {
      brandOrNetworkSelectedVal = null
    } else if (brandOrNetworkSelected.some(brandOrNetworkSelected => brandOrNetworkSelected)) {
      brandOrNetworkSelectedVal = true
    }

    api.voohCampaign
      .getVoohCampaignsForTable({
        first: pageNumber * itemsPerPage,
        last: itemsPerPage,
        sortColumn: tableFilter.column,
        sortDirection: tableFilter.direction,
        filters:
          brandOrNetworkSelectedVal !== null
            ? { ...filtersObj, brandOrNetworkSelected: brandOrNetworkSelectedVal }
            : { ...filtersObj },
      })
      .then(res => {
        const { voohCampaigns } = res.data
        const mappedCampaigns: VoohCampaignTableItem[] = voohCampaigns.nodes.map(
          (campaign): VoohCampaignTableItem => ({
            id: campaign.id,
            name: campaign.name,
            startDate: campaign.startDate,
            endDate: campaign.endDate,
            status:
              CampaignStatus[
                EnumUtils.getKeyByValue(
                  CampaignStatus,
                  campaign.status
                ) as keyof typeof CampaignStatus
              ],
            agencyName: campaign.agency.name,
            supervisors: (campaign.supervisors || []).map(s => `${s.firstName} ${s.lastName}`),
          })
        )
        setCampaigns(mappedCampaigns)
        setTotalCount(voohCampaigns.totalCount)
      })
      .catch(() => void {})
      .finally(() => {
        setLoading(false)
        setTrigger(false)
      })
  }

  static deleteCampaign = (
    campaignId: VoohCampaign['id'],
    setTrigger: React.Dispatch<React.SetStateAction<boolean>>,
    addNotification: (type: NotifierType, text: string | string[], time?: number) => void,
    t: TFunction
  ): Promise<void> =>
    api.voohCampaign
      .destroyVoohCampaign(campaignId)
      .then(res => {
        if (!res.data) {
          return
        }

        const { success } = res.data.destroyVoohCampaign
        if (success) {
          addNotification(NotifierType.SUCCESS, t('form.campaign.removal.success'))
        }
      })
      .catch(() => void {})
      .finally(() => void setTrigger(true))
}
